import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../environments/environment';

/** Prepends environment.apiBaseUrl for relative API calls (e.g. proxy to ASP.NET in dev). Sends cookies (AuthToken) for API auth. */
export const apiBaseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  const base = (environment.apiBaseUrl ?? '').replace(/\/$/, '');
  let url = req.url;
  if (base && !url.startsWith('http://') && !url.startsWith('https://')) {
    const path = url.startsWith('/') ? url : `/${url}`;
    url = `${base}${path}`;
  }
  return next(req.clone({ url, withCredentials: true }));
};
